export const SITE = {
  name: 'Ayam Goreng Widuran',
  domain: 'https://ayamgorengwiduran.com',
  tagline: 'Ayam Kampung Goreng Kremes Khas Solo',
  since: '1973',
  ogImage:
    'https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?w=1200&h=630&q=80&auto=format&fit=crop',
  instagram: {
    solo: 'https://www.instagram.com/ayamgorengwiduransolo',
    bali: 'https://www.instagram.com/ayamwiduranbali',
  },
};

export const IMG = {
  hero: 'https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?w=1200&q=80&auto=format&fit=crop',
  ayamGoreng: 'https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=1000&q=80&auto=format&fit=crop',
  ayamBakar: 'https://images.unsplash.com/photo-1630315500315-43112e2bfd88?w=1000&q=80&auto=format&fit=crop',
  sambal: 'https://images.unsplash.com/photo-1661830974665-7da532cfaba2?w=1000&q=80&auto=format&fit=crop',
  nasiDaun: 'https://images.unsplash.com/photo-1707270686195-7415251cc9c0?w=1000&q=80&auto=format&fit=crop',
  urap: 'https://images.unsplash.com/photo-1666239308347-4292ea2ff777?w=1000&q=80&auto=format&fit=crop',
  heritage: 'https://images.unsplash.com/photo-1600015835779-c6b36ddeac1f?w=1400&q=80&auto=format&fit=crop',
  interior: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1400&q=80&auto=format&fit=crop',
  rice: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?w=1000&q=80&auto=format&fit=crop',
};

export const OUTLETS = [
  {
    id: 'solo-widuran',
    name: 'Widuran — Outlet Utama',
    badge: 'Pusat · Sejak 1973',
    address: 'Jl. Sutan Syahrir No. 71, Kepatihan Kulon, Kec. Jebres, Kota Surakarta, Jawa Tengah',
    hours: 'Setiap hari · buka pagi (± 07.00 WIB) hingga sore',
    maps: 'https://www.google.com/maps/search/?api=1&query=Ayam+Goreng+Widuran+Jl+Sutan+Syahrir+No+71+Jebres+Surakarta',
    instagram: SITE.instagram.solo,
    igHandle: '@ayamgorengwiduransolo',
  },
  {
    id: 'solo-sudirman',
    name: 'Sudirman Square',
    badge: 'Cabang Kota Solo',
    address: 'Ruko Sudirman Square (Jl. Arifin) No. 5, Kota Surakarta, Jawa Tengah',
    hours: null,
    maps: 'https://www.google.com/maps/search/?api=1&query=Ruko+Sudirman+Square+Jl+Arifin+Surakarta',
    instagram: SITE.instagram.solo,
    igHandle: '@ayamgorengwiduransolo',
  },
  {
    id: 'bali-denpasar',
    name: 'Imam Bonjol — Denpasar',
    badge: 'Cabang Bali',
    address: 'Jl. Imam Bonjol No. 371, Denpasar Barat, Kota Denpasar, Bali',
    hours: null,
    maps: 'https://www.google.com/maps/search/?api=1&query=Jl+Imam+Bonjol+No+371+Denpasar+Barat+Bali',
    instagram: SITE.instagram.bali,
    igHandle: '@ayamwiduranbali',
  },
];

export const MENU_CATEGORIES = [
  {
    id: 'ayam-goreng',
    name: 'Ayam Kampung Goreng',
    note: 'Ayam kampung pilihan, digoreng hingga keemasan dan garing.',
    items: [
      { name: 'Ayam Kampung Goreng — 1 Ekor', price: '± Rp130.000', desc: 'Satu ekor ayam kampung utuh, cocok untuk lauk keluarga.' },
      { name: 'Ayam Kampung Goreng — per Potong', price: '± Rp33.000', desc: 'Pilihan bagian paha atau dada, disajikan hangat.' },
      { name: 'Kremesan Khas Widuran', price: '± Rp25.000', desc: 'Serpihan gurih nan renyah — ikon rumah makan ini sejak 1973.' },
    ],
  },
  {
    id: 'ayam-bakar',
    name: 'Ayam Bakar',
    note: 'Dibakar dengan bumbu manis-gurih khas.',
    items: [
      { name: 'Ayam Kampung Bakar — per Potong', price: null, desc: 'Ayam kampung bakar dengan olesan bumbu khas Widuran.' },
    ],
  },
  {
    id: 'pendamping',
    name: 'Sambal & Pendamping',
    note: 'Pelengkap wajib di setiap piring.',
    items: [
      { name: 'Sambal Bawang', price: null, desc: 'Sambal bawang pedas segar.' },
      { name: 'Sambal Matah', price: null, desc: 'Irisan bawang, cabai, dan serai khas Bali.' },
      { name: 'Lalapan Segar', price: null, desc: 'Sayuran segar pendamping ayam goreng.' },
      { name: 'Kepala Ayam Goreng', price: null, desc: 'Untuk penggemar bagian klasik yang gurih.' },
      { name: 'Rempela Ati', price: null, desc: 'Rempela ati goreng bumbu khas.' },
    ],
  },
  {
    id: 'layanan',
    name: 'Pesanan & Layanan',
    note: 'Untuk acara, oleh-oleh, dan stok di rumah.',
    items: [
      { name: 'Nasi Box / Nasi Kotak', price: null, desc: 'Menerima pesanan nasi box untuk acara dan jumlah besar.' },
      { name: 'Frozen Food', price: null, desc: 'Pilihan produk beku siap goreng untuk dibawa pulang.' },
    ],
  },
];

export const FAQS = [
  {
    q: 'Apakah Ayam Goreng Widuran halal?',
    a: 'Tidak. Sejak Mei 2025, pengelola secara terbuka menyatakan bahwa produk Ayam Goreng Widuran non-halal. Label non-halal dipasang jelas di outlet, etalase, dan kemasan agar pelanggan dapat memilih dengan sadar. Kami berterima kasih atas pengertian seluruh pelanggan.',
  },
  {
    q: 'Di mana alamat Ayam Goreng Widuran?',
    a: 'Outlet utama berada di Jl. Sutan Syahrir No. 71, Kepatihan Kulon, Kec. Jebres, Kota Surakarta (Solo). Ada pula cabang di Ruko Sudirman Square (Jl. Arifin) No. 5, Solo, dan di Jl. Imam Bonjol No. 371, Denpasar, Bali.',
  },
  {
    q: 'Jam berapa Ayam Goreng Widuran buka?',
    a: 'Outlet utama Solo melayani setiap hari, umumnya buka pagi sekitar pukul 07.00 WIB hingga sore. Jam operasional dapat berubah pada hari tertentu — silakan pantau Instagram resmi @ayamgorengwiduransolo untuk informasi terkini.',
  },
  {
    q: 'Apa itu kremesan?',
    a: 'Kremesan adalah serpihan adonan berbumbu yang digoreng hingga garing dan renyah, disajikan menutupi ayam goreng. Di Widuran, kremesan menjadi ciri khas yang membedakan ayam gorengnya sejak 1973.',
  },
  {
    q: 'Apakah menerima pesanan nasi box atau dalam jumlah besar?',
    a: 'Ya, Widuran menerima pesanan nasi box untuk acara keluarga, kantor, dan kebutuhan jumlah besar. Silakan hubungi kami melalui Instagram resmi atau datang langsung ke outlet untuk pemesanan.',
  },
  {
    q: 'Apakah tersedia frozen food?',
    a: 'Ya, tersedia pilihan produk frozen (beku) yang bisa dibawa pulang dan digoreng sendiri di rumah. Ketersediaan stok dapat berbeda setiap hari.',
  },
  {
    q: 'Apakah ada cabang di luar Solo?',
    a: 'Ada. Cabang luar kota berada di Jl. Imam Bonjol No. 371, Denpasar, Bali, dengan Instagram resmi @ayamwiduranbali.',
  },
  {
    q: 'Bagaimana cara memesan tanpa datang langsung?',
    a: 'Saat ini kanal resmi kami adalah kunjungan langsung ke outlet dan pesan melalui Instagram @ayamgorengwiduransolo. Untuk layanan pesan-antar daring, silakan tanyakan ketersediaannya melalui Instagram.',
  },
];

export const NAV = [
  { to: '/', label: 'Beranda', testid: 'nav-beranda' },
  { to: '/menu/', label: 'Menu', testid: 'nav-menu' },
  { to: '/tentang/', label: 'Tentang', testid: 'nav-tentang' },
  { to: '/lokasi/', label: 'Lokasi', testid: 'nav-lokasi' },
  { to: '/faq/', label: 'FAQ', testid: 'nav-faq' },
  { to: '/kontak/', label: 'Kontak', testid: 'nav-kontak' },
];

const restaurantLd = {
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  name: 'Ayam Goreng Widuran',
  url: SITE.domain + '/',
  image: SITE.ogImage,
  servesCuisine: ['Ayam goreng kampung', 'Masakan Indonesia', 'Masakan Jawa'],
  foundingDate: '1973',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Jl. Sutan Syahrir No. 71, Kepatihan Kulon, Jebres',
    addressLocality: 'Kota Surakarta',
    addressRegion: 'Jawa Tengah',
    addressCountry: 'ID',
  },
  sameAs: [SITE.instagram.solo, SITE.instagram.bali],
};

const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Ayam Goreng Widuran',
  url: SITE.domain + '/',
  inLanguage: 'id-ID',
};

const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: SITE.domain + it.path,
  })),
});

const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const crumbs = (name, path) => breadcrumbLd([{ name: 'Beranda', path: '/' }, { name, path }]);

export const ROUTES = [
  {
    path: '/',
    file: 'index.html',
    title: 'Ayam Goreng Widuran Solo — Ayam Kampung Goreng Kremes Sejak 1973',
    description:
      'Ayam Goreng Widuran: rumah makan ayam kampung goreng kremes khas Solo sejak 1973 di Jl. Sutan Syahrir No. 71. Lihat menu, lokasi outlet Solo & Bali, dan cara memesan.',
    h1: true,
    jsonld: [restaurantLd, websiteLd],
  },
  {
    path: '/menu/',
    file: 'menu/index.html',
    title: 'Daftar Menu & Harga — Ayam Goreng Widuran Solo',
    description:
      'Menu Ayam Goreng Widuran Solo: ayam kampung goreng kremes, ayam bakar, sambal bawang, sambal matah, lalapan, nasi box, dan frozen food. Harga terkini tersedia di outlet.',
    jsonld: [breadcrumbLd ? crumbs('Menu', '/menu/') : null].filter(Boolean),
  },
  {
    path: '/tentang/',
    file: 'tentang/index.html',
    title: 'Tentang — Sejarah Ayam Goreng Widuran Sejak 1973',
    description:
      'Mengenal Ayam Goreng Widuran, rumah makan keluarga di Solo yang berdiri sejak 1973 dan dikenal lewat ayam kampung goreng kremesnya, serta komitmen keterbukaan kepada pelanggan.',
    jsonld: [crumbs('Tentang', '/tentang/')],
  },
  {
    path: '/lokasi/',
    file: 'lokasi/index.html',
    title: 'Lokasi Outlet — Ayam Goreng Widuran Solo & Denpasar Bali',
    description:
      'Alamat outlet Ayam Goreng Widuran: Jl. Sutan Syahrir No. 71 Solo, Ruko Sudirman Square Solo, dan Jl. Imam Bonjol No. 371 Denpasar Bali. Lihat petunjuk arah di Google Maps.',
    jsonld: [crumbs('Lokasi', '/lokasi/')],
  },
  {
    path: '/kontak/',
    file: 'kontak/index.html',
    title: 'Kontak — Ayam Goreng Widuran Solo',
    description:
      'Hubungi Ayam Goreng Widuran melalui Instagram resmi @ayamgorengwiduransolo, atau kunjungi langsung outlet kami di Solo dan Denpasar, Bali.',
    jsonld: [crumbs('Kontak', '/kontak/')],
  },
  {
    path: '/faq/',
    file: 'faq/index.html',
    title: 'FAQ — Tanya Jawab Seputar Ayam Goreng Widuran',
    description:
      'Pertanyaan yang sering diajukan seputar Ayam Goreng Widuran: status non-halal, alamat outlet, jam buka, pesanan nasi box, frozen food, dan cara memesan.',
    jsonld: [faqLd, crumbs('FAQ', '/faq/')],
  },
];

export const ROUTE_404 = {
  path: '/404.html',
  file: '404.html',
  noindex: true,
  title: 'Halaman Tidak Ditemukan — Ayam Goreng Widuran',
  description: 'Halaman yang Anda cari tidak ditemukan di situs Ayam Goreng Widuran.',
  jsonld: [],
};

const esc = (s) => s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

export function headFor(route) {
  const parts = [];
  if (route.noindex) {
    parts.push('<meta name="robots" content="noindex"/>');
  } else {
    const url = SITE.domain + route.path;
    parts.push(`<link rel="canonical" href="${url}"/>`);
    parts.push('<meta property="og:type" content="website"/>');
    parts.push('<meta property="og:site_name" content="Ayam Goreng Widuran"/>');
    parts.push('<meta property="og:locale" content="id_ID"/>');
    parts.push(`<meta property="og:title" content="${esc(route.title)}"/>`);
    parts.push(`<meta property="og:description" content="${esc(route.description)}"/>`);
    parts.push(`<meta property="og:url" content="${url}"/>`);
    parts.push(`<meta property="og:image" content="${SITE.ogImage}"/>`);
    parts.push('<meta name="twitter:card" content="summary_large_image"/>');
    parts.push(`<meta name="twitter:title" content="${esc(route.title)}"/>`);
    parts.push(`<meta name="twitter:description" content="${esc(route.description)}"/>`);
    parts.push(`<meta name="twitter:image" content="${SITE.ogImage}"/>`);
  }
  for (const ld of route.jsonld) {
    parts.push(`<script type="application/ld+json">${JSON.stringify(ld)}</script>`);
  }
  return parts.join('\n');
}
